import { render, staticRenderFns } from "./servicerMessage.vue?vue&type=template&id=cfabe466&scoped=true"
import script from "./servicerMessage.vue?vue&type=script&lang=js"
export * from "./servicerMessage.vue?vue&type=script&lang=js"
import style0 from "./servicerMessage.vue?vue&type=style&index=0&id=cfabe466&prod&lang=css"
import style1 from "./servicerMessage.vue?vue&type=style&index=1&id=cfabe466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfabe466",
  null
  
)

export default component.exports